import axios from 'axios';

export default {
    state: {
        regions: null,
        regionsFI: null,
    },
    getters: {
        getRegions(state) {
            return state.regions
        },
        getRegionsFI(state) {
            return state.regionsFI
        },
    },
    mutations: {
        setRegions(state, data) {
            return state.regions = data
        },
        setRegionsFI(state, data) {
            return state.regionsFI = data
        },
    },
    actions: {
        regionsRequest(context) {
            return axios.get('/api/dictionaries/regions')
                .then(res => {
                    context.commit('setRegions', res.data)
                })
        },
        regionsFIRequest(context) {
            return axios.get('/api/dictionaries/regions-by-fi')
                .then(res => {
                    context.commit('setRegionsFI', res.data)
                })
        },
    }
}